import { render } from "./ProjectsPage.vue?vue&type=template&id=ab25ca98&scoped=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&lang=js"

import "./ProjectsPage.vue?vue&type=style&index=0&id=ab25ca98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab25ca98"]])

export default __exports__